// Bridges Local Mode's "View" action to the Android app's native RTSP
// player (parvekshak_webview/lib/local_rtsp_player.dart). A browser <video>
// element has no RTSP support at all — there's no codec/protocol path for
// it — so this deliberately isn't an HTTP call to any Parvekshak service:
// the phone decodes the stream itself, straight from the camera's RTSP port
// on the LAN. No backend, no session to open or close server-side. See
// docs/local-mode-changes-design.md for why (Local Mode camera viewing must
// keep working even with the Python backend down).
//
// In the browser/PWA build there is no Flutter host to hand this off to —
// isNativePlayerAvailable() lets the UI show a fallback message there
// instead of a "View" button that can never do anything.

export function isNativePlayerAvailable() {
  return typeof window !== 'undefined' && !!window.FlutterRtspView;
}

export function buildRtspUrl({ protocol, host, port, path, username, password }) {
  const auth = username ? `${encodeURIComponent(username)}:${encodeURIComponent(password || '')}@` : '';
  const cleanPath = path ? (path.startsWith('/') ? path : `/${path}`) : '';
  return `${protocol || 'rtsp'}://${auth}${host}:${port || 554}${cleanPath}`;
}

// Fires the native player and returns immediately — playback and its
// lifecycle (close button, errors) are entirely owned by the native view;
// the web layer has no session state to track.
export function playNativeRtsp(camera, { username, password } = {}) {
  if (!isNativePlayerAvailable()) return false;
  const rtsp_url = buildRtspUrl({ ...camera, username, password });
  window.FlutterRtspView.postMessage(JSON.stringify({
    rtsp_url,
    transport: camera.transport || 'tcp',
    name: camera.name || camera.host,
  }));
  return true;
}
